export const facebooklink = "https://www.facebook.com/saigonstareats/";

export const instagramlink = "https://www.instagram.com/saigon.star/?hl=en";
